import * as bookingProcess from './transactionProcessBooking';

export const transitions = {
  ...bookingProcess.transitions,
  SEAL_CUSTOMER_LOCATION: 'transition/seal-customer-location',
  EXPIRE_LOCATION_SEAL: 'transition/expire-location-seal',
  OPEN_ATTENDANCE_CONFIRMATION: 'transition/open-attendance-confirmation',
  CUSTOMER_CONFIRM_ATTENDANCE: 'transition/customer-confirm-attendance',
  PROVIDER_CONFIRM_ATTENDANCE: 'transition/provider-confirm-attendance',
  PROVIDER_CONFIRM_AFTER_CUSTOMER: 'transition/provider-confirm-after-customer',
  CUSTOMER_CONFIRM_AFTER_PROVIDER: 'transition/customer-confirm-after-provider',
  PROVIDER_MARK_COMPLETED: 'transition/provider-mark-completed',
  PROVIDER_MARK_COMPLETED_AFTER_MORE_WORK: 'transition/provider-mark-completed-after-more-work',
  CUSTOMER_CONFIRM_COMPLETION: 'transition/customer-confirm-completion',
  CUSTOMER_MARK_WORK_INCOMPLETE: 'transition/customer-mark-work-incomplete',
  AUTO_CONFIRM_COMPLETION: 'transition/auto-confirm-completion',
  CUSTOMER_CANCEL_BEFORE_SERVICE: 'transition/customer-cancel-before-service',
  CUSTOMER_CANCEL_SERVICE_DAY: 'transition/customer-cancel-service-day',
  PROVIDER_CANCEL_BEFORE_SERVICE: 'transition/provider-cancel-before-service',
  OPERATOR_REFUND_CUSTOMER_CANCELLATION:
    'transition/operator-refund-customer-cancellation',
  OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION:
    'transition/operator-pay-provider-customer-cancellation',
  OPERATOR_CONFIRM_PARTIAL_CANCELLATION: 'transition/operator-confirm-partial-cancellation',
  CUSTOMER_REPORT_PROBLEM: 'transition/customer-report-problem',
  PROVIDER_MARK_COMPLETED_AFTER_PROBLEM: 'transition/provider-mark-completed-after-problem',
  CUSTOMER_CONFIRM_COMPLETION_AFTER_CORRECTION:
    'transition/customer-confirm-completion-after-correction',
  AUTO_CONFIRM_COMPLETION_AFTER_CORRECTION: 'transition/auto-confirm-completion-after-correction',
  CUSTOMER_REPORT_PROBLEM_AFTER_CORRECTION: 'transition/customer-report-problem-after-correction',
  CUSTOMER_REPORT_PROBLEM_TO_RESUELVEPR: 'transition/customer-report-problem-to-resuelvepr',
  CUSTOMER_CONFIRM_COMPLETION_AFTER_PROVIDER_PROBLEM:
    'transition/customer-confirm-completion-after-provider-problem',
  CUSTOMER_ESCALATE_PROBLEM_TO_RESUELVEPR: 'transition/customer-escalate-problem-to-resuelvepr',
  PROVIDER_MARK_CORRECTION_COMPLETED: 'transition/provider-mark-correction-completed',
  CUSTOMER_CONFIRM_CORRECTED_SERVICE: 'transition/customer-confirm-corrected-service',
  AUTO_CONFIRM_CORRECTED_SERVICE: 'transition/auto-confirm-corrected-service',
  CUSTOMER_REPORT_CORRECTED_SERVICE_TO_RESUELVEPR:
    'transition/customer-report-corrected-service-to-resuelvepr',
  OPERATOR_REFUND_SERVICE_COMPLETION: 'transition/operator-refund-service-completion',
  OPERATOR_PAY_PROVIDER_SERVICE_COMPLETION: 'transition/operator-pay-provider-service-completion',
  EXPIRE_PROVIDER_COMPLETION: 'transition/expire-provider-completion',
};

export const states = {
  ...bookingProcess.states,
  PENDING_LOCATION_SEAL: 'pending-location-seal',
  CONFIRMATION_OPEN: 'confirmation-open',
  CUSTOMER_CONFIRMED: 'customer-confirmed',
  PROVIDER_CONFIRMED: 'provider-confirmed',
  BOTH_CONFIRMED: 'both-confirmed',
  PROVIDER_COMPLETED: 'provider-completed',
  WORK_PENDING: 'work-pending',
  CANCELED_BEFORE_CONFIRMATION: 'canceled-before-confirmation',
  PROBLEM_REPORTED: 'problem-reported',
  PROVIDER_COMPLETED_FINAL: 'provider-completed-final',
  PROVIDER_CORRECTION_COMPLETED: 'provider-correction-completed',
  MANUAL_REVIEW: 'manual-review',
  COMPLETION_REVIEW: 'completion-review',
  COMPLETION_REFUNDED: 'completion-refunded',
  COMPLETION_PAID_TO_PROVIDER: 'completion-paid-to-provider',
  CANCELLATION_REVIEW: 'cancellation-review',
  CANCELLATION_REFUNDED: 'cancellation-refunded',
  CANCELLATION_PAID_TO_PROVIDER: 'cancellation-paid-to-provider',
  PARTIALLY_REFUNDED: 'partially-refunded',
  PROVIDER_COMPLETION_EXPIRED: 'provider-completion-expired',
};

export const graph = {
  ...bookingProcess.graph,
  id: 'resuelvepr-booking/release-1',
  states: {
    ...bookingProcess.graph.states,
    [states.INITIAL]: {
      on: {
        [transitions.INQUIRE]: states.INQUIRY,
        [transitions.REQUEST_PAYMENT]: states.PENDING_LOCATION_SEAL,
      },
    },
    [states.ACCEPTED]: {
      on: {
        [transitions.CANCEL]: states.CANCELED,
        [transitions.COMPLETE]: states.DELIVERED,
        [transitions.OPERATOR_COMPLETE]: states.DELIVERED,
        [transitions.OPEN_ATTENDANCE_CONFIRMATION]: states.CONFIRMATION_OPEN,
        ['transition/customer-cancel-accepted']: states.CANCELED_BEFORE_CONFIRMATION,
        ['transition/provider-cancel-accepted']: states.CANCELED_BEFORE_CONFIRMATION,
        [transitions.CUSTOMER_CANCEL_BEFORE_SERVICE]: states.CANCELED,
        [transitions.CUSTOMER_CANCEL_SERVICE_DAY]: states.CANCELLATION_REVIEW,
        [transitions.PROVIDER_CANCEL_BEFORE_SERVICE]: states.CANCELED,
        [transitions.PROVIDER_MARK_COMPLETED]: states.PROVIDER_COMPLETED,
        [transitions.EXPIRE_PROVIDER_COMPLETION]: states.PROVIDER_COMPLETION_EXPIRED,
      },
    },
    [states.PENDING_LOCATION_SEAL]: {
      on: {
        [transitions.SEAL_CUSTOMER_LOCATION]: states.PENDING_PAYMENT,
        [transitions.EXPIRE_LOCATION_SEAL]: states.PAYMENT_EXPIRED,
      },
    },
    [states.CONFIRMATION_OPEN]: {
      on: {
        [transitions.CUSTOMER_CONFIRM_ATTENDANCE]: states.CUSTOMER_CONFIRMED,
        [transitions.PROVIDER_CONFIRM_ATTENDANCE]: states.PROVIDER_CONFIRMED,
        ['transition/customer-cancel-confirmation-open']: states.CANCELED_BEFORE_CONFIRMATION,
        ['transition/provider-cancel-confirmation-open']: states.CANCELED_BEFORE_CONFIRMATION,
      },
    },
    [states.CUSTOMER_CONFIRMED]: {
      on: {
        [transitions.PROVIDER_CONFIRM_AFTER_CUSTOMER]: states.BOTH_CONFIRMED,
        ['transition/customer-cancel-customer-confirmed']: states.CANCELED_BEFORE_CONFIRMATION,
        ['transition/provider-cancel-customer-confirmed']: states.CANCELED_BEFORE_CONFIRMATION,
      },
    },
    [states.PROVIDER_CONFIRMED]: {
      on: {
        [transitions.CUSTOMER_CONFIRM_AFTER_PROVIDER]: states.BOTH_CONFIRMED,
        ['transition/customer-cancel-provider-confirmed']: states.CANCELED_BEFORE_CONFIRMATION,
        ['transition/provider-cancel-provider-confirmed']: states.CANCELED_BEFORE_CONFIRMATION,
      },
    },
    [states.BOTH_CONFIRMED]: {
      on: {
        [transitions.PROVIDER_MARK_COMPLETED]: states.PROVIDER_COMPLETED,
      },
    },
    [states.PROVIDER_COMPLETED]: {
      on: {
        [transitions.CUSTOMER_CONFIRM_COMPLETION]: states.DELIVERED,
        [transitions.CUSTOMER_MARK_WORK_INCOMPLETE]: states.WORK_PENDING,
        [transitions.CUSTOMER_REPORT_PROBLEM]: states.PROBLEM_REPORTED,
        [transitions.CUSTOMER_REPORT_PROBLEM_TO_RESUELVEPR]: states.COMPLETION_REVIEW,
        [transitions.AUTO_CONFIRM_COMPLETION]: states.DELIVERED,
      },
    },
    [states.WORK_PENDING]: {
      on: {
        [transitions.PROVIDER_MARK_COMPLETED_AFTER_MORE_WORK]: states.PROVIDER_COMPLETED,
      },
    },
    [states.PROBLEM_REPORTED]: {
      on: {
        [transitions.PROVIDER_MARK_COMPLETED_AFTER_PROBLEM]: states.PROVIDER_COMPLETED_FINAL,
        [transitions.CUSTOMER_CONFIRM_COMPLETION_AFTER_PROVIDER_PROBLEM]: states.DELIVERED,
        [transitions.CUSTOMER_ESCALATE_PROBLEM_TO_RESUELVEPR]: states.COMPLETION_REVIEW,
        [transitions.PROVIDER_MARK_CORRECTION_COMPLETED]: states.PROVIDER_CORRECTION_COMPLETED,
      },
    },
    [states.PROVIDER_CORRECTION_COMPLETED]: {
      on: {
        [transitions.CUSTOMER_CONFIRM_CORRECTED_SERVICE]: states.DELIVERED,
        [transitions.AUTO_CONFIRM_CORRECTED_SERVICE]: states.DELIVERED,
        [transitions.CUSTOMER_REPORT_CORRECTED_SERVICE_TO_RESUELVEPR]: states.COMPLETION_REVIEW,
      },
    },
    [states.PROVIDER_COMPLETED_FINAL]: {
      on: {
        [transitions.CUSTOMER_CONFIRM_COMPLETION_AFTER_CORRECTION]: states.DELIVERED,
        [transitions.AUTO_CONFIRM_COMPLETION_AFTER_CORRECTION]: states.DELIVERED,
        [transitions.CUSTOMER_REPORT_PROBLEM_AFTER_CORRECTION]: states.MANUAL_REVIEW,
      },
    },
    [states.MANUAL_REVIEW]: {},
    [states.COMPLETION_REVIEW]: {
      on: {
        [transitions.OPERATOR_REFUND_SERVICE_COMPLETION]: states.COMPLETION_REFUNDED,
        [transitions.OPERATOR_PAY_PROVIDER_SERVICE_COMPLETION]: states.COMPLETION_PAID_TO_PROVIDER,
      },
    },
    [states.COMPLETION_REFUNDED]: {},
    [states.COMPLETION_PAID_TO_PROVIDER]: {},
    [states.CANCELLATION_REVIEW]: {
      on: {
        [transitions.OPERATOR_REFUND_CUSTOMER_CANCELLATION]: states.CANCELLATION_REFUNDED,
        [transitions.OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION]:
          states.CANCELLATION_PAID_TO_PROVIDER,
        [transitions.OPERATOR_CONFIRM_PARTIAL_CANCELLATION]: states.PARTIALLY_REFUNDED,
      },
    },
    [states.CANCELLATION_REFUNDED]: {},
    [states.CANCELLATION_PAID_TO_PROVIDER]: {},
    [states.PARTIALLY_REFUNDED]: {},
  },
};

const release2PrivilegedTransitions = [transitions.SEAL_CUSTOMER_LOCATION];

export const isRelevantPastTransition = transition =>
  transition?.includes('-cancel-') ||
  [
    transitions.OPEN_ATTENDANCE_CONFIRMATION,
    transitions.CUSTOMER_CONFIRM_ATTENDANCE,
    transitions.PROVIDER_CONFIRM_ATTENDANCE,
    transitions.PROVIDER_CONFIRM_AFTER_CUSTOMER,
    transitions.CUSTOMER_CONFIRM_AFTER_PROVIDER,
    transitions.PROVIDER_MARK_COMPLETED,
    transitions.PROVIDER_MARK_COMPLETED_AFTER_MORE_WORK,
    transitions.PROVIDER_MARK_COMPLETED_AFTER_PROBLEM,
    transitions.CUSTOMER_CONFIRM_COMPLETION,
    transitions.CUSTOMER_CONFIRM_COMPLETION_AFTER_CORRECTION,
    transitions.CUSTOMER_MARK_WORK_INCOMPLETE,
    transitions.CUSTOMER_REPORT_PROBLEM,
    transitions.CUSTOMER_REPORT_PROBLEM_AFTER_CORRECTION,
    transitions.CUSTOMER_REPORT_PROBLEM_TO_RESUELVEPR,
    transitions.CUSTOMER_CONFIRM_COMPLETION_AFTER_PROVIDER_PROBLEM,
    transitions.CUSTOMER_ESCALATE_PROBLEM_TO_RESUELVEPR,
    transitions.PROVIDER_MARK_CORRECTION_COMPLETED,
    transitions.CUSTOMER_CONFIRM_CORRECTED_SERVICE,
    transitions.AUTO_CONFIRM_CORRECTED_SERVICE,
    transitions.CUSTOMER_REPORT_CORRECTED_SERVICE_TO_RESUELVEPR,
    transitions.OPERATOR_REFUND_SERVICE_COMPLETION,
    transitions.OPERATOR_PAY_PROVIDER_SERVICE_COMPLETION,
    transitions.CUSTOMER_CANCEL_SERVICE_DAY,
    transitions.OPERATOR_REFUND_CUSTOMER_CANCELLATION,
    transitions.OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION,
    transitions.AUTO_CONFIRM_COMPLETION,
    transitions.AUTO_CONFIRM_COMPLETION_AFTER_CORRECTION,
    transitions.EXPIRE_PROVIDER_COMPLETION,
    ...release2PrivilegedTransitions,
  ].includes(transition) ||
  bookingProcess.isRelevantPastTransition(transition);

export const isPrivileged = transition =>
  release2PrivilegedTransitions.includes(transition) ||
  [
    // The published v1 process requires trusted credentials for provider acceptance.
    transitions.ACCEPT,
    transitions.CUSTOMER_CANCEL_BEFORE_SERVICE,
    transitions.CUSTOMER_CANCEL_SERVICE_DAY,
    transitions.PROVIDER_CANCEL_BEFORE_SERVICE,
    transitions.PROVIDER_MARK_COMPLETED,
    transitions.PROVIDER_MARK_COMPLETED_AFTER_MORE_WORK,
    transitions.CUSTOMER_REPORT_PROBLEM,
    transitions.PROVIDER_MARK_COMPLETED_AFTER_PROBLEM,
    transitions.CUSTOMER_REPORT_PROBLEM_AFTER_CORRECTION,
    transitions.CUSTOMER_REPORT_PROBLEM_TO_RESUELVEPR,
    transitions.CUSTOMER_ESCALATE_PROBLEM_TO_RESUELVEPR,
    transitions.PROVIDER_MARK_CORRECTION_COMPLETED,
    transitions.CUSTOMER_REPORT_CORRECTED_SERVICE_TO_RESUELVEPR,
  ].includes(transition) ||
  bookingProcess.isPrivileged(transition);

export const isCompleted = transition =>
  [
    transitions.CUSTOMER_CONFIRM_COMPLETION,
    transitions.CUSTOMER_CONFIRM_COMPLETION_AFTER_CORRECTION,
    transitions.CUSTOMER_CONFIRM_COMPLETION_AFTER_PROVIDER_PROBLEM,
    transitions.AUTO_CONFIRM_COMPLETION,
    transitions.AUTO_CONFIRM_COMPLETION_AFTER_CORRECTION,
    transitions.CUSTOMER_CONFIRM_CORRECTED_SERVICE,
    transitions.AUTO_CONFIRM_CORRECTED_SERVICE,
    transitions.OPERATOR_PAY_PROVIDER_CUSTOMER_CANCELLATION,
    transitions.OPERATOR_PAY_PROVIDER_SERVICE_COMPLETION,
  ].includes(transition) || bookingProcess.isCompleted(transition);
export const isRefunded = transition =>
  (transition?.includes('-cancel-') && transition !== transitions.CUSTOMER_CANCEL_SERVICE_DAY) ||
  transition === transitions.OPERATOR_REFUND_CUSTOMER_CANCELLATION ||
  transition === transitions.OPERATOR_REFUND_SERVICE_COMPLETION ||
  transition === transitions.EXPIRE_PROVIDER_COMPLETION ||
  bookingProcess.isRefunded(transition);
export const isCustomerReview = bookingProcess.isCustomerReview;
export const isProviderReview = bookingProcess.isProviderReview;
export const statesNeedingProviderAttention = [
  ...bookingProcess.statesNeedingProviderAttention,
  states.PROBLEM_REPORTED,
];
export const statesNeedingCustomerAttention = [
  ...bookingProcess.statesNeedingCustomerAttention,
  states.PROVIDER_COMPLETED,
  states.PROVIDER_COMPLETED_FINAL,
  states.PROVIDER_CORRECTION_COMPLETED,
];
